<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.56787 16.8611H3.46363L4.24444 16.0803C4.66544 15.6593 4.92835 15.1117 4.99903
    14.5177C3.19612 13.3345 2.29883 11.6205 2.29883 9.82361C2.29883 6.50854 5.34569 3.13965 10.1174
    3.13965C15.1726 3.13965 17.8832 6.23966 17.8832 9.53317C17.8832 12.8484 15.1439 15.9463 10.1174
    15.9463C9.23691 15.9463 8.31809 15.8288 7.49776 15.6131C6.72122 16.4096 5.66906
    16.8611 4.56787 16.8611V16.8611Z" stroke="#0D7BC4" stroke-width="1.7"/>
  </svg>
</template>

<script>
export default {
  name: 'BBPIconDescription'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPIcons/BBPIconDescription.vue